<template>
    <div class="two-factor-auth">
      <h2>Configuración de Autenticación de Dos Factores</h2>
      <div v-if="!is2FAEnabled">
        <p>Para activar la autenticación de dos factores, primero escanea el siguiente código QR con tu aplicación de autenticación.</p>
        <img :src="qrCodeUrl" alt="2FA QR Code">
        <div>
          <input v-model="otp" placeholder="Ingrese el código OTP" />
          <button @click="verifyOTP">Verificar y Activar</button>
        </div>
      </div>
      <div v-else>
        <p>La autenticación de dos factores está activada.</p>
        <button @click="disable2FA">Desactivar 2FA</button>
      </div>
    </div>
  </template>
  
  <script>
  import api from "@/services/api";
  
  export default {
    data() {
      return {
        is2FAEnabled: false,
        qrCodeUrl: '',
        otp: ''
      };
    },
    mounted() {
      this.fetchQRCode();
    },
    methods: {
      fetchQRCode() {
        api.get('/otp/setup')
          .then(response => {
            this.qrCodeUrl = response.data.qrCodeUrl;
          })
          .catch(error => console.error('Error fetching QR code:', error));
      },
      verifyOTP() {
        api.post('/otp/verify', { otp: this.otp })
          .then(response => {
            if (response.data.success) {
              this.is2FAEnabled = true;
              alert('2FA is now enabled.');
            } else {
              alert('Failed to verify OTP.');
            }
          })
          .catch(error => {
            alert('Error verifying OTP: ' + error.message);
          });
      },
      disable2FA() {
        api.post('/user/2fa/disable')
          .then(() => {
            this.is2FAEnabled = false;
            alert('2FA has been disabled.');
          })
          .catch(error => {
            alert('Error disabling 2FA: ' + error.message);
          });
      }
    }
  }
  </script>
  
  <style>
  .two-factor-auth {
    max-width: 400px;
    margin: auto;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  
  .two-factor-auth input, .two-factor-auth button {
    width: 100%;
    padding: 10px;
    margin-top: 5px;
  }
  </style>  